import React, { useRef } from 'react';
import { Box, Modal, ModalOverlay, useBreakpointValue } from '@chakra-ui/react';
import { useNavigate } from '@reach/router';

import ModalContent from './components/ModalContent';
import { IMPACT_OVERVIEW_URL } from '../../utils/constants';
import { detailsText } from './text-content/details';

const ImpactDetailsUpsell = () => {
  const navigate = useNavigate();
  const modalBoundary = useRef<HTMLDivElement>(null);

  return (
    <Box
      ref={modalBoundary}
      position="fixed"
      top={{ base: 16, lg: 0 }}
      left={{ base: 0, lg: 250 }}
      right={0}
      bottom={0}
      zIndex="modal"
    >
      <Modal
        scrollBehavior="outside"
        blockScrollOnMount={false}
        isOpen={true}
        onClose={() => navigate(IMPACT_OVERVIEW_URL)}
        closeOnOverlayClick={false}
        portalProps={{ containerRef: modalBoundary }}
        size={useBreakpointValue({ base: 'full', md: '4xl' }) ?? 'full'}
      >
        <ModalOverlay position="absolute" bg="#F0F0F0" />
        <ModalContent
          variant="details"
          onDismiss={() => navigate(IMPACT_OVERVIEW_URL)}
          text={detailsText}
        />
      </Modal>
    </Box>
  );
};

export default ImpactDetailsUpsell;
